<div class="qe">

  <header class="qe__header">
    <button type="button" class="qe__back" (click)="onCancel()">
      <i class="fa-solid fa-arrow-left" aria-hidden="true"></i>
      {{ 'QUESTION_EDIT.BACK' | translate }}
    </button>
    <div>
      <h1 class="qe__title">
        <i class="fa-solid fa-pen-to-square qe__title-icon" aria-hidden="true"></i>
        {{ 'QUESTION_EDIT.TITLE' | translate }}
      </h1>
      @if (heading()) {
        <p class="qe__subtitle" [title]="heading() | mathPlain"><app-math-text [text]="heading()" [inline]="true"></app-math-text></p>
      }
    </div>
  </header>

  @if (loading()) {
    <div class="qe__loading" role="status" aria-live="polite">
      <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
      {{ 'QUESTION_EDIT.LOADING' | translate }}
    </div>
  } @else if (errored()) {
    <app-error-state
      titleKey="QUESTION_EDIT.ERROR_TITLE"
      messageKey="QUESTION_EDIT.ERROR_MESSAGE"
      (retry)="retry()">
    </app-error-state>
  } @else if (initial()) {
    <app-question-source [source]="source()"></app-question-source>

    <app-question-editor
      [initialValue]="initial()"
      (save)="onSave($event)"
      (cancel)="onCancel()">
    </app-question-editor>
  }

</div>
